<template>
  <main>
    <section>
        <div class="text-left pt-2 pl-4" style="font-size: 16px;">
          <!-- {{ this.$route.path.slice(1) }} -->
        </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'RouteNav',
  computed: {
  },
  methods: {
  }
};
</script>
<style scoped>
@import '../../assets/css/main.css';
</style>
